const en_US = {
    //'Type': 'Type',
    //'RealTimeType' : 'RealTimeType'
    "MarkerContent":"This is the {{place}} marker"
}

export default en_US;